module.exports = __webpack_public_path__ + "static/media/menuLunch.70f8e5c5.png";